import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL, BUSINESS, NAV_LINKS } from "../constants";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#0A1930] text-slate-300 pt-20 pb-10" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid md:grid-cols-12 gap-10 md:gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Néma Services" className="w-14 h-14 object-contain bg-white p-1" />
              <div>
                <div className="font-display font-semibold text-xl text-white tracking-tight">
                  NÉMA
                </div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-[#2E9E6E] font-medium">
                  Services
                </div>
              </div>
            </div>
            <p className="mt-6 text-slate-400 leading-relaxed max-w-md text-sm">
              Entreprise de nettoyage professionnel basée en Île-de-France.
              Nous accompagnons entreprises, commerces, copropriétés et sites
              industriels avec des prestations sur mesure, fiables et
              éco-responsables.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#2E9E6E] font-medium mb-5">
              Navigation
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-[#2E9E6E] font-medium mb-5">
              Contact
            </div>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${BUSINESS.phoneRaw}`}
                  className="flex items-center gap-3 group hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-4 h-4 text-[#2E9E6E]" strokeWidth={1.75} />
                  {BUSINESS.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${BUSINESS.email}`}
                  className="flex items-center gap-3 group hover:text-white transition-colors break-all"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-[#2E9E6E] flex-shrink-0" strokeWidth={1.75} />
                  {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#2E9E6E]" strokeWidth={1.75} />
                {BUSINESS.zone}
              </li>
            </ul>

            <a
              href="#devis"
              className="mt-8 inline-flex items-center gap-2 bg-[#2E9E6E] hover:bg-[#25825a] text-white px-5 py-3 text-sm font-medium transition-colors"
              data-testid="footer-cta-devis"
            >
              Demander un devis →
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 text-xs text-slate-500">
          <div>
            © {year} Néma Services — Tous droits réservés.
          </div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Mentions légales</a>
            <a href="#" className="hover:text-white transition-colors">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
